export default __webpack_public_path__ + "static/media/food.d408f900.png";